module.exports = __webpack_public_path__ + "img/logo1.76f2bf95.png";